import React, { useEffect, useRef, useState } from "react";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import CustomPageHeader from "../../components/customPageHeader/CustomPageHeader";
import { SubText } from "../../components/typographyText/TypographyText";
import "./Customer.scss";
import {
  Button,
  ContextMenu,
  SelectBox,
  LoadPanel,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import { custPwdDataSource, custStatusDataSource } from "./data";
import { useNavigate } from "react-router-dom";
import { confirm } from "devextreme/ui/dialog";
import {
  customer_delete,
  fetchCustomerData,
} from "../../api/companyCustomerApi";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { useAuth } from "../../contexts/auth";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";

export default function Customer() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const dataGridRef = useRef(null);
  const [custDataSource, setCustDataSource] = useState([]);
  const [passwordFilter, setPasswordFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [loading, setLoading] = useState(true);
  const [displayedTicketCount, setDisplayedTicketCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const updateDisplayedTicketCount = () => {
    if (dataGridRef.current?.instance) {
      const totalCount = dataGridRef.current.instance.totalCount();
      setDisplayedTicketCount(totalCount || 0);
    }
  };

  const loadCustomerData = async () => {
    try {
      const res = await fetchCustomerData(user?.companytransid);
      if (!res || !res?.data || res.data?.length === 0) {
        // ToastDisplayer("error", "Data not Found");
        return; // Return early if no data
      }
      if (res && res?.data && res?.data?.length > 0) {
        // ToastDisplayer("success", "Data Displayed Successfully");
        const modifiedData = res?.data?.map((customer) => {
          const projectNames =
            customer.assigned_projects?.flatMap((category) =>
              category.subcategories?.map((sub) => sub.ticketsubcatname),
            ) || [];

          return {
            ...customer,
            custstatus: customer.custstatus === "active" ? "A" : "I",
            projectDisplay: projectNames, // keep as array
          };
        });
        setCustDataSource(modifiedData);
      }
    } catch (err) {
      ToastDisplayer(
        "error",
        err?.response?.data?.error ||
          err?.response?.data?.detail ||
          err?.response?.data?.code,
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCustomerData();
  }, []);

  const handleDeleteCustomer = async (custid) => {
    try {
      setLoading(true);
      const result = await customer_delete(custid);

      if (result) {
        ToastDisplayer("success", "Customer deleted successfully!");
        loadCustomerData();
      } else {
        ToastDisplayer("error", "Failed to delete customer.");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error || "Something went wrong.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (custid) => {
    confirm("Are you sure you want to delete this record?").then((result) => {
      if (result) {
        // setCustDataSource((prevData) =>
        //   prevData.filter((item) => item["custcode"] !== custid)
        // );

        handleDeleteCustomer(custid);
      }
    });
  };

  const onCloneIconClick = (e) => {
    const selectedRowData = e?.data;
  };

  const actionTemplate = (cellData) => {
    const actionMenuItems = [
      {
        icon: "ri-archive-drawer-fill",
        text: "Assign Projects",
        onClick: () => {
          // console.log(
          //   "Navigating to Assign Projects with data:",
          //   cellData?.data,
          // );
          navigate("/client/Assign-Projects", {
            state: { custdata: cellData?.data },
            // state: { custcode: cellData.data.custcode, custname: cellData.data.custname },
          });
        },
      },
      {
        icon: "ri-pencil-fill",
        text: "Edit & View",
        onClick: () => {
          navigate("/client/Edit-client", {
            state: { custcode: cellData.data["custcode"] },
          });
        },
      },
      {
        icon: "ri-delete-bin-fill",
        text: "Delete",
        onClick: () => {
          handleDelete(cellData.data["custcode"]);
        },
      },
    ];

    const sanitizeClassName = (str) => {
      return String(str).replace(/[^a-zA-Z0-9_-]/g, "");
    };

    const sanitizedClassName = `actionbtn-${sanitizeClassName(
      cellData.data["custcode"],
    )}`;
    const renderItem = (item) => (
      <div className="action-icon">
        <i className={item.icon}></i>
        <span className="action-text">{item.text}</span>
      </div>
    );

    return (
      <>
        <div className="nextPageBtn">
          <div
            className={sanitizedClassName}
            onClick={() => onCloneIconClick(cellData)}
          >
            <i className="ri-more-fill"></i>
          </div>
        </div>
        <ContextMenu
          items={actionMenuItems}
          target={`.${sanitizedClassName}`}
          showEvent="dxclick"
          cssClass="actionMenu"
          itemRender={renderItem}
        />
      </>
    );
  };

  const getStatusColor = (status) => {
    const statusColors = {
      Active: "#0C6230",
      Inactive: "#910000",
    };
    return statusColors[status];
  };

  const handlePwdFilterChange = (newFilter) => {
    setPasswordFilter(newFilter);
    const filterValue = newFilter === "All" ? null : newFilter;

    //   if (dataGridRef.current && dataGridRef.current.instance) {
    //     dataGridRef.current.instance.columnOption(
    //       "passwordreq",
    //       "filterValue",
    //       filterValue
    //     );
    //   }
    // };
    if (dataGridRef.current?.instance) {
      dataGridRef.current.instance.columnOption(
        "passwordreq",
        "filterValue",
        filterValue,
      );
    }
  };

  const handleStatusFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    const filterValue = newFilter === "All" ? undefined : newFilter;
    if (dataGridRef.current && dataGridRef.current.instance) {
      dataGridRef.current.instance.columnOption(
        "custstatus",
        "filterValue",
        filterValue,
      );
      // dataGridRef.current.instance.refresh();
    }
  };

  const handleCreateNew = () => {
    navigate("/client/Add-client");
  };

  //Function to mask the phone number :
  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const visiblePart = phone.slice(0, 4);
    const maskedPart = "X".repeat(phone.length - 4);

    return visiblePart + maskedPart;
  };

  // export functionality for custom  Export Button
  const handleExport = () => {
    const grid = dataGridRef.current?.instance;
    if (!grid) return;

    const selectedKeys = grid.getSelectedRowKeys();

    if (selectedKeys.length > 0) {
      grid.exportToExcel(true); // selected rows
    } else {
      grid.exportToExcel(false); // fallback → all rows
    }
  };

  const onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tickets");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      const now = new Date();

      const formattedDate = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

      const fileName = `Clients_${formattedDate}.xlsx`; // ✅ dynamic name

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName,
        );
      });
    });

    e.cancel = true; // ❗ VERY IMPORTANT (stops default export)
  };

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-user-add-line"></i>
              </span>
              <p>Client</p>
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Export"
              icon="export"
              stylingMode="outlined"
              type="default"
              width={120}
              onClick={handleExport}
            />
            <Button
              className="addBtn"
              text="Add Client"
              icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCreateNew}
            />

            {/* <CustomPageHeader
              // titleName={"Customers"}
              handleCreateNew={handleCreateNew}
              btnText={"Add Client"}
            /> */}
          </div>
        </div>
        <div className="datagridContainer">
          <div className="mainDatagrid middlePart">
            <DataGrid
              loadPanel={true}
              width={"100%"}
              height={"100%"}
              className={"custGrid"}
              dataSource={custDataSource}
              ref={dataGridRef}
              allowColumnReordering={true}
              rowAlternationEnabled={false}
              // columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnHeaders={true}
              onContentReady={updateDisplayedTicketCount}
              onExporting={onExporting}
            >
              <Export enabled={true} />
              <Toolbar>
                <Item location="before">
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>
                    <SubText text={`Total ${displayedTicketCount} Client`} />
                  </div>
                </Item>
                <Item name="searchPanel" />
                {/* <Item name="exportButton" /> */}
                <Item location="after">
                  <SelectBox
                    width={150}
                    height={44}
                    id="filterStatus"
                    valueExpr="value"
                    displayExpr="text"
                    stylingMode="outlined"
                    className="selectboxStatus"
                    placeholder="All Status"
                    items={custStatusDataSource}
                    value={statusFilter}
                    onValueChanged={(e) => handleStatusFilterChange(e.value)}
                  />
                </Item>
              </Toolbar>

              <SearchPanel visible={true} width={200} placeholder="Search" />

              <Selection mode="multiple" showCheckBoxesMode="always" />
              <Scrolling mode="virtual" />

              {/* <Paging defaultPageSize={10} /> */}

              <Pager
                visible={true}
                allowedPageSizes={[10, 20, 30]}
                // showPageSizeSelector={true}
              />
              <Paging defaultPageSize={10} />

              <Column
                width={230}
                dataField={"custname"}
                caption="CLIENT NAME"
                cellRender={(data) => {
                  return (
                    <div className="customer-cell">{data.data["custname"]}</div>
                  );
                }}
              />

              <Column
                alignment="center"
                width={100}
                allowSorting={false}
                allowSearch={false}
                cellRender={(cellData) => actionTemplate(cellData)}
              />

              <Column
                width={140}
                alignment="center"
                dataField="custstatus"
                caption={"CLIENT STATUS"}
                hidingPriority={6}
                cellRender={(data) => {
                  const value = data["value"] === "A" ? "Active" : "Inactive";
                  return (
                    <>
                      <span className="col-main2" data-type={value}>
                        <span
                          className="cust-status-circle"
                          style={{
                            backgroundColor: getStatusColor(value),
                          }}
                        />
                        <span
                          data-type={value}
                          style={{
                            color: getStatusColor(value),
                            fontWeight: "500",
                          }}
                        >
                          {value}
                        </span>
                      </span>
                    </>
                  );
                }}
              />

              <Column
                width={270}
                alignment="center"
                dataField="custcode"
                caption="CODE"
                hidingPriority={5}
              />
              <Column
                width={240}
                alignment="left"
                dataField="custemail"
                caption="EMAIL ID"
                hidingPriority={4}
              />
              <Column
                width={160}
                dataField="isotpverified"
                caption="OTP VERIFIED"
                alignment="center"
                hidingPriority={3}
                cellRender={(data) => {
                  const value = data.value === "Y" ? "Yes" : "No";
                  return <span>{value}</span>;
                }}
              />

              <Column
                width={270}
                alignment="left"
                dataField="cntctname"
                caption="CONTACT PERSON NAME"
                hidingPriority={2}
                cellRender={({ data }) => <span>{data.cntctname || "-"}</span>}
              />

              <Column
                width={230}
                alignment={"center"}
                dataField="custphno"
                caption="CONTACT NUMBER"
                hidingPriority={1}
                cellRender={(data) => {
                  return maskPhoneNumber(data?.data?.custphno);
                }}
              />
              <Column
                caption="PROJECTS"
                hidingPriority={0}
                cellRender={({ data }) => {
                  if (!data.projectDisplay || data.projectDisplay.length === 0)
                    return <span>-</span>;

                  return (
                    <div className="project-wrapper">
                      {(() => {
                        const projects = data.projectDisplay || [];
                        const limit = 5;

                        if (projects.length === 0) return <span>-</span>;

                        const visible = projects.slice(0, limit);
                        const hasMore = projects.length > limit;

                        return (
                          <>
                            <span>
                              {visible.map((proj, index) => (
                                <span key={index}>
                                  {proj}
                                  {index < visible.length - 1 && ", "}
                                </span>
                              ))}
                              {hasMore && "..."}
                            </span>
                          </>
                        );
                      })()}
                    </div>
                  );
                }}
              />

              <Column
                dataField={"entry_date"}
                defaultSortOrder="desc"
                visible={false}
              />
            </DataGrid>
          </div>
        </div>
      </div>
    </>
  );
}
